webpackJsonp([263791100135453],{

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/chilling.9c0792a4.svg";

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(67);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _chilling = __webpack_require__(125);
	
	var _chilling2 = _interopRequireDefault(_chilling);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutPage = function AboutPage() {
	  return _react2.default.createElement(
	    "div",
	    { className: "flex flex-col md:flex-row items-center" },
	    _react2.default.createElement(
	      "div",
	      { className: "md:w-2/3 md:mr-8" },
	      _react2.default.createElement(
	        "p",
	        { className: "border-l-4 border-grey-darkest font-serif leading-loose pl-4 text-justify" },
	        "Value in computer and software design lies in simplicity"
	      ),
	      _react2.default.createElement(
	        "p",
	        { className: "font-bold mt-4 text-left text-xs uppercase" },
	        "Founded in 2009, 24/7 Software is the sole proprietorship of Andrew Bruce, P.Eng. Specializing in mobile app and custom hardware and software solutions. Contact me today to chat about your project."
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "w-2/3 md:w-1/3" },
	      _react2.default.createElement("img", { src: _chilling2.default })
	    )
	  );
	};
	
	exports.default = AboutPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-df4cb30a4a79e9d8b2da.js